module.exports = __webpack_public_path__ + "img/a5617b6.jpg";